import { useEffect, useState } from 'react'
import { CellProps } from 'react-table'
import { Link } from 'react-router-dom'
import BaseTable from '../../components/BaseTable/BaseTable'
import DashboardWrapper from '../../components/MainDashboardWrapper/DashboardWrapper'
import { formatDate } from '../../helpers/dateUtils'
import { campaignSignupUrl, conversionRate, getSignupCampaigns } from './helper'

const Tile = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="bg-white rounded-xl shadow-md p-6 flex flex-col gap-3">
    <span className="text-sm font-semibold text-gray-500">{label}</span>
    <span className="text-3xl font-extrabold text-[#0B1D3A] leading-none">{value}</span>
  </div>
)

export default function TrackingPage() {
  const [campaigns, setCampaigns] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    getSignupCampaigns()
      .then((res) => setCampaigns(res.data.data || []))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [])

  const totalVisits = campaigns.reduce((sum, c) => sum + c.visits, 0)
  const totalSignups = campaigns.reduce((sum, c) => sum + c.signups, 0)

  const columns: any[] = [
    {
      Header: 'Campaign',
      accessor: 'campaign',
      Cell: (cellProps: CellProps<any>) => (
        <Link className="no-underline font-bold" to={`/tracking/${cellProps.value}`}>
          {cellProps.value}
        </Link>
      ),
    },
    {
      Header: 'Signup link',
      id: 'link',
      accessor: 'campaign',
      Cell: (cellProps: CellProps<any>) => (
        <span className="text-xs text-gray-500 break-all">{campaignSignupUrl(cellProps.value)}</span>
      ),
    },
    { Header: 'Clicks', accessor: 'visits' },
    { Header: 'Unique visitors', accessor: 'uniqueVisitors' },
    { Header: 'Accounts created', accessor: 'signups' },
    { Header: 'Coaches', accessor: 'coachSignups' },
    { Header: 'Participants', accessor: 'participantSignups' },
    {
      Header: 'Conversion',
      id: 'conversion',
      accessor: (row: any) => conversionRate(row.signups, row.visits),
    },
    {
      Header: 'Last activity',
      accessor: 'lastActivity',
      Cell: (cellProps: CellProps<any>) => formatDate(cellProps.value),
    },
  ]

  return (
    <DashboardWrapper page="tracking" title="Signup Tracking">
      <div className="flex flex-col gap-5">
        {error && (
          <p className="text-sm text-red-600">Couldn't load tracking data from the server — reload to retry.</p>
        )}
        <div className="grid grid-cols-4 gap-4">
          <Tile label="Campaigns" value={loading ? '—' : campaigns.length} />
          <Tile label="Total clicks" value={loading ? '—' : totalVisits} />
          <Tile label="Accounts created" value={loading ? '—' : totalSignups} />
          <Tile label="Conversion" value={loading ? '—' : conversionRate(totalSignups, totalVisits)} />
        </div>
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-sm text-gray-500 mb-4">
            Share <span className="font-mono">{campaignSignupUrl('your-keyword')}</span> in a campaign — any keyword works
            and shows up here after the first click.
          </p>
          <BaseTable data={campaigns} columns={columns} loading={loading} />
        </div>
      </div>
    </DashboardWrapper>
  )
}
